import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { Icon } from 'Components/Icons';
import { PurpleButton } from 'Components/Button';

import classes from './noEquipmentPlaceholder.module.css';

interface Props {
  onAddButtonClick: (e: any) => void;
}

const NoEquipmentPlaceholder = ({ onAddButtonClick }: Props) => (
  <div className={`d-flex justify-content-center align-items-center flex-column w-100 ${classes.noEquipmentContent}`}>
    <p className={classes.noEquipmentText}>No equipment added.</p>
    <Icon type="rocketemblemsmall" />
    <PurpleButton className={classes.addButton} onClick={onAddButtonClick}>
      Add Equipment
    </PurpleButton>
  </div>
);

const NoEquipmentPlaceholderMemo = memo(NoEquipmentPlaceholder, areEqual);

export { NoEquipmentPlaceholderMemo as NoEquipmentPlaceholder };
